import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-text',
  imports: [],
  template: `@if (props.text) {
    <h3 [innerHTML]="props.label"></h3>
    <div class="text-md text-default pb-4" [innerHTML]="props.text"></div>
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyTextComponent extends FieldType<any> {}
